import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('ourSpots')}},[_c('header-button',{attrs:{"slot":"right-button","icon":"mdi-plus-box","right":"","label":_vm.$t('new'),"to":{ name: 'administration-spot-add' }},slot:"right-button"})],1),_c(VContainer,[_c('spot-administration-list-card',{attrs:{"spots":_vm.spots}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }